import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './quasar';
import hljs from "highlight.js/lib/highlight";
import xml from "highlight.js/lib/languages/xml";
hljs.registerLanguage("xml", xml);
import VueHljsLite from "vue-hljs-lite";
import 'highlight.js/styles/darcula.css';
import VueParticlesGenerator from 'vue-particles-generator';

import Clipboard from 'v-clipboard'

Vue.config.productionTip = false;
Vue.use(Clipboard);
Vue.use(VueHljsLite, { hljs });
Vue.use(VueParticlesGenerator);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
